import { matchPath } from "react-router-dom-v5-compat";

import { ROUTES } from "routing/routes";

export function isInParentPlatform(pathname: string) {
  return matchPath(`${ROUTES.PARENT.path}/*`, pathname);
}

export function isInParentPremium(pathname: string) {
  return matchPath(`${ROUTES.PARENT.WHAT_IS_PREMIUM.path}/*`, pathname);
}
